module.exports = __webpack_public_path__ + "img/48_10.574f5215.png";